import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import SideMenu from '../views/layouts/SideMenu.vue';

// import LoggedContainer from '@/views/layouts/containers/LoggedContainer.vue';
import GuestContainer from '@/views/layouts/containers/GuestContainer.vue';
import SmartLoggedGuestContainer from '@/views/layouts/containers/SmartLoggedGuestContainer.vue';

import LoginPage from '@/views/pages/auth/LoginPage.vue';
import CardsComparisonPage from "@/views/pages/cards/CardsComparisonPage.vue";
import OauthLoginPage from "@/views/pages/auth/OauthLoginPage.vue";
import GuestEmptyContainer from "@/views/layouts/containers/GuestEmptyContainer.vue";
import PageNotFound from "@/views/pages/errors/PageNotFound.vue";
import RegistrationSetupPage from "@/views/pages/auth/RegistrationSetupPage.vue";
import EmptyContainer from "@/views/layouts/containers/EmptyContainer.vue";
import RegistrationSuperShortPage from "@/views/pages/auth/RegistrationSuperShortPage.vue";

Vue.use(VueRouter);

// const beforeEnter = (to, from, next) => {
//   if (to.name !== 'Login' /*&& !isAuthenticated*/) next({ name: 'Login' })
//   else next()
// };

const routes = [

  {
    path: '/',
    name: 'root',
    component: SmartLoggedGuestContainer, // LoggedContainer,
    props: true,
    redirect: '/index',
    children: [
      {
        path: 'index',
        name: 'Dash board',
        component: Home,
      },
      {
        path: '/profile/update/:type',
        name: '/profile/update/:type',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/profile/ProfileUpdateSelect.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: '/profile/update',
        name: '/profile/update',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/profile/ProfileUpdateSelect.vue'),
          sidemenu: SideMenu,
        },
      },

      {
        path: '/finance/payout/:system',
        name: '/finance/payout/:system',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/finance/payout/PayoutRequisitesPage.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: '/finance/payout/:system/account/:account',
        name: '/finance/payout/:system/account/:account',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/finance/payout/PayoutRequisitesPage.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: '/finance/payout/:system/:document',
        name: '/finance/payout/:system/:document',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/finance/payout/PayoutRequisitesPage.vue'),
          sidemenu: SideMenu,
        },
      },

      {
        path: '/finance/test',
        name: '/finance/test',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/Home.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: 'cards_public_offer_agreement',
        name: 'Public offer agreement',
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/cards/ApplepayPublicOfferAgreement.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: 'cards_walleto_agreement',
        name: 'Public offer agreement',
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/cards/WalletoAgreement.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: 'finance',
        name: 'accounts',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/finance/AccountsPage.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: 'finance/accounts_vue',
        name: 'accounts_vue',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/finance/AccountsPage.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: 'security/googlecode',
        name: 'security/googlecode',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/security/GooglecodeSettingsPage.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: 'profile/updatelegal',
        name: 'profile/updatelegal',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/profile/LegalVerificationApplication.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: 'about',
        name: 'About',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: 'contacts',
        name: 'Contacts',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/contacts/Contacts.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: 'privacypolicy',
        name: 'PrivacyPolicy',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        components: {
          default: () => import(/* webpackChunkName: "privacy" */ '../views/pages/site/PrivacyPolicy.vue'),
          sidemenu: SideMenu,
        },
        meta: {
          guest: true,
        },
      },

      {
        path: 'merchants/deposit/:id',
        props: {
          default: (route) => ({ id: route.params.id }),
        },
        components: {
          default: () => import(/* webpackChunkName: "merchants-orders" */ '../views/pages/merchants/marketplace/DepositMerchantOrder.vue'),
          sidemenu: SideMenu,
        },
        meta: {
          guest: true,
        },
      },

      {
        path: 'merchants/deposit/:id/capitalist',
        props: {
          default: (route) => ({ id: route.params.id }),
        },
        components: {
          default: () => import(/* webpackChunkName: "merchants-orders" */ '../views/pages/merchants/marketplace/DepositMerchantOrderCapitalist.vue'),
          sidemenu: SideMenu,
        },
        meta: {
          guest: true,
        },
      },

      {
        path: 'merchants/orders/:id',
        props: {
          default: (route) => ({ id: route.params.id }),
        },
        components: {
          default: () => import(/* webpackChunkName: "merchants-orders" */ '../views/pages/merchants/MerchantOrdersPage.vue'),
          sidemenu: SideMenu,
        },
        meta: {
          guest: true,
        },
      },
      {
        path: 'finance/deposit/usdt',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/finance/deposit/usdt/DepositUsdtTransferPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
      {
        path: 'finance/deposit/usdc',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/finance/deposit/usdc/DepositUsdcTransferPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
      {
        path: 'finance/deposit/bitcoin',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/finance/deposit/bitcoin/DepositBitcoinPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
      {
        path: 'finance/deposit/ethereum',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/finance/deposit/ethereum/DepositEthereumPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
      {
        path: 'finance/deposit/qiwi',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/finance/deposit/temp/QiwiDepositPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
      {
        path: 'finance/deposit/p2p-rucards',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/finance/deposit/rucards/DepositRoublesViaRucardsPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
      {
        path: 'finance/deposit/ethereum',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/finance/deposit/ethereum/DepositEthereumPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
      {
        path: 'finance/deposit/wire',
        components: {
          default: () => import(/* webpackChunkName: "wires" */ '../views/pages/finance/deposit/WireDepositBlock.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
      {
        path: 'merchants',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/merchants/MerchantsListPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
      {
        path: 'merchants/finance-reports',
        props: {
          default: (route) => ({ merchantid: route.params.id }),
        },
        components: {
          default: () => import(/* webpackChunkName: "merchants-finance" */ '../views/pages/merchants/MerchantFinanceReportsPage.vue'),
          sidemenu: SideMenu,
        },
        meta: {
          guest: true,
        },
        children: [
          {
            path: '',
            props: {
              default: (route) => ({ merchantid: route.params.id }),
            },
            components: {
              default: () => import(/* webpackChunkName: "merchants-finance" */ '../views/pages/merchants/MerchantFinanceReportsPage.vue'),
              sidemenu: SideMenu,
            },
            meta: {
              guest: true,
            },
          },
          {
            path: ':id',
            props: {
              default: (route) => ({ merchantid: route.params.id }),
            },
            components: {
              default: () => import(/* webpackChunkName: "merchants-finance" */ '../views/pages/merchants/MerchantFinanceReportsPage.vue'),
              sidemenu: SideMenu,
            },

          },
        ],
      },

      {
        path: 'merchants/:id/:number',
        props: (route) => ({ merchantId: route.params.id, orderNumber: route.params.number }),
        components: {
          default: () => import(/* webpackChunkName: "merchants-orders" */ '../views/pages/merchants/MerchantOrderDetailsPage.vue'),
          sidemenu: SideMenu,
        },
        meta: {
          guest: true,
        },
      },
      {
        path: 'privacypolicylog',
        name: 'PrivacyPolicyLogin',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        components: {
          default: () => import(/* webpackChunkName: "privacy" */ '../views/pages/site/PrivacyPolicy.vue'),
          sidemenu: SideMenu,
        },
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: 'customer-support-feedback/:reqid',
        props: {
          default: (route) => ({ reqid: route.params.reqid }),
        },
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/support/SupportReview.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
      {
        path: 'profile/referral',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/referral/ReferralPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
    ],
  },
  {
    path: '/cards-comparison',
    name: 'Cards Comparison',
    component: GuestContainer,
    children: [
      {
        path: '/',
        component: CardsComparisonPage,
        meta: {
          guest: true,
        },
      }
    ]
  },
  {
    path: '/login',
    component: GuestContainer,
    children: [
      {
        path: '/',
        name: 'Login',
        component: LoginPage,
        meta: {
          guest: true,
        },
      },
    ],
  },
  {
    path: '/oauth',
    component: GuestEmptyContainer,
    children: [
      {
        path: '/',
        name: 'OauthLogin',
        component: OauthLoginPage,
        meta: {
          guest: true,
        },
      },
    ],
  },
  {
    path: '/reg',
    component: GuestContainer,
    children: [
      {
        path: '/',
        name: 'Registration',
        component: RegistrationSetupPage,
        meta: {
          guest: true,
        },
      },
      // {
      //   path: '/setup',
      //   name: 'Registration',
      //   component: RegistrationSetupPage,
      //   meta: {
      //     guest: true,
      //   },
      // },
    ],
  },

  {
    path: '/reg-promo',
    component: GuestContainer,
    // GuestContainer,
    children: [
      {
        path: '/',
        // props: {
        //   default: (route) => ({ id: route.params.id }),
        // },
        name: 'Registration',
        component: RegistrationSuperShortPage,
        meta: {
          guest: true,
        },
      },
      {
        path: '/reg-promo/:from',
        props: {
          default: (route) => ({ from: route.params.from }),
        },
        name: 'Registration',
        component: RegistrationSuperShortPage,
        meta: {
          guest: true,
        },
      }
      // {
      //   path: '/setup',
      //   name: 'Registration',
      //   component: RegistrationSetupPage,
      //   meta: {
      //     guest: true,
      //   },
      // },
    ],
  },

  // {
  //   path: '/reg2',
  //   component: GuestContainer,
  //   children: [
  //     {
  //       path: '/',
  //       name: 'Registration',
  //       component: RegistrationSetupPage,
  //       meta: {
  //         guest: true,
  //       },
  //     },
  //   ],
  // },
  {
    path: '/test',
    name: 'Test',
    redirect: '/test/index',
    component: GuestContainer,
    children: [
      {
        path: 'index',
        name: 'Dashboard',
        component: Home,
      },
    ],
  },

  {
    path: '*',
    component: PageNotFound
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   if(to.matched.some(record => record.meta.requiresAuth)) {
//     if (localStorage.getItem('jwt') == null) {
//       next({
//         path: '/login',
//         params: { nextUrl: to.fullPath }
//       })
//     } else {
//       let user = JSON.parse(localStorage.getItem('user') as string)
//       next()
//     }
//   } else if(to.matched.some(record => record.meta.guest)) {
//     if(localStorage.getItem('jwt') == null){
//       next()
//     }
//     else{
//       next({ name: 'userboard'})
//     }
//   }else {
//     next()
//   }
// })
//

export default router;
